<template>
  <v-fade-transition>
    <div v-if="show" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-logo">
          <v-icon size="60" color="grey-lighten-1" class="mb-4">mdi-car-door</v-icon>
        </div>
        <h2 class="text-h4 font-weight-light mb-4 text-grey-lighten-2">
          {{ viteConfig('APP_NAME') }}
        </h2>
        <v-progress-circular
          indeterminate
          size="40"
          width="3"
          color="grey-lighten-1"
          class="mb-4"
        ></v-progress-circular>
        <p class="text-body-2 text-grey-lighten-1 opacity-75">
          {{ $t('common.loading') }}
        </p>
      </div>
    </div>
  </v-fade-transition>
</template>

<script setup>
import { viteConfig } from '@/services/utils';

defineProps({
  show: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  color: #e0e0e0;
  padding: 2rem;
}

.loading-logo {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Fade transition for smoother experience */
.v-fade-transition-enter-active,
.v-fade-transition-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.v-fade-transition-enter-from,
.v-fade-transition-leave-to {
  opacity: 0;
}
</style>